import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { PHOTO_REVIEW_UISTATE } from '../../photo-review/model/photo-review.constant';
import { QualityState } from '../../state/quality.state';
import { Observable, Subject } from 'rxjs';
import { OrderDetailModel } from '../../state/model/order-detail.model';
import { Store } from '@ngxs/store';
import { takeUntil } from 'rxjs/operators';

// State
import { PhotoUtilsService } from '../../photo-review/service/photo-review-utils.service';
import { PhotoReviewState } from '../../photo-review/state/photo-review.state';

@Component({
	selector: 'cv-cvds-photos',
	templateUrl: './cvds-photos.component.html',
	styleUrls: ['./cvds-photos.component.scss']
})
export class CvdsPhotosComponent implements OnInit, OnDestroy {
	@Input() photos = [];
	@Input() width100 = false;
	orderDetail$: Observable<OrderDetailModel> = this.store.select(QualityState.getOrderDetail);

	selectedSchema: any;
	items = [];
	private atComponentDestroy = new Subject();
	photoReviewUiState: any;

	constructor(private photoUtils: PhotoUtilsService, private store: Store) {
		this.photoReviewUiState = PHOTO_REVIEW_UISTATE;
	}

	async ngOnInit(): Promise<void> {
		this.orderDetail$
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((orderDetailModel: OrderDetailModel) => {
				this.selectedSchema = orderDetailModel.schema;
			});

		const photos = this.getPhotosInStore(this.photos);
		this.items = this.photoUtils.mapAllPhoto(photos)[0];
	}

	/**
	 * getPhotosInStore
	 * Get Photos from Store
	 */
	getPhotosInStore(photos: Array<any>): Array<any> {
		const currentPhotos = this.store.selectSnapshot(PhotoReviewState.getPhotoReviewCollection);
		const photosFiltered = currentPhotos.filter(photo => {
			const { photoRefJsonPath } = photo.metadata;
			return this.photos.some(elem => elem.photoRefJsonPath.Value === photoRefJsonPath);
		});
		return photosFiltered;
	}

	/**
	 * Close all when the element is destroyed
	 * in case a Sub Component remains visible
	 */
	ngOnDestroy(): void {
		// Globally Destroy anything attached to it
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
